
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { InputContainer } from '../inputContainer/InputContainer'
import { Button } from '../Button/Button'

export const SearchContainer = ({
  inputValue,
  inputDisabled,
  inputPlaceholder,
  resetLabel,
  searchLabel,
  isAdvanced,
  advacedSarchIsOpen,
  className,
  hasCustomSearch,
  children,
  onChangeInputSearch,
  resetCallBack,
  searchCallback,
  advancedCallBack,
  searchContainerClassname,
  buttonsContainerClassname
}) => {
  const containerClasses = classNames(className, 'row m-bottom-thin', {})

  const searchContainerClasses = classNames('col-xs-9', 'p-left-0', searchContainerClassname)

  const buttonsContainerClasses = classNames('col-xs-3', 'p-right-0', buttonsContainerClassname)

  const containerBtnSerachClasses = classNames('f-right', {
    'btn-group-select': isAdvanced
  })

  const advacedSarchClass = classNames('btn-group-select_advanced-search', {
    'is-open': advacedSarchIsOpen,
    'is-close': !advacedSarchIsOpen
  })

  function search () {
    searchCallback()
  }

  function reset () {
    resetCallBack()
  }

  const propsInputSearch = {
    value: inputValue,
    maxLength: 5000,
    placeholder: inputPlaceholder,
    onChange: onChangeInputSearch,
    enablePressEnter: true,
    pressEnterCallback: search,
    disabled: inputDisabled
  }

  const propsBtnSearch = {
    kind: 'secondary',
    onClick: search,
    className: 'btn-text btn-medium test-searchButton'
  }

  const propsBtnReset = {
    kind: 'neutral',
    onClick: reset,
    className: 'm-right-button test-resetButton'
  }

  return (
    <div className={containerClasses}>
      <div className={searchContainerClasses}>
        {!hasCustomSearch && <InputContainer {...propsInputSearch} />}
        {children}
      </div>
      <div className={buttonsContainerClasses}>
        <div className={containerBtnSerachClasses}>
          <Button {...propsBtnSearch}>{searchLabel}</Button>
          {isAdvanced && <a className='btn-icon btn-medium test-searchAdvanced' onClick={advancedCallBack} >
            <span className={advacedSarchClass} />
          </a>}
        </div>
        <Button {...propsBtnReset}>{resetLabel}</Button>
      </div>
    </div>

  )
}

SearchContainer.defaultProps = {
  inputValue: ''
}

SearchContainer.propTypes = {
  inputValue: PropTypes.string,
  inputDisabled: PropTypes.bool,
  inputPlaceholder: PropTypes.string,
  className: PropTypes.string,
  resetLabel: PropTypes.string,
  searchLabel: PropTypes.string,
  isAdvanced: PropTypes.bool,
  resetCallBack: PropTypes.func,
  saerchCallback: PropTypes.func,
  advancedCallBack: PropTypes.func,
  searchContainerClassname: PropTypes.string,
  buttonsContainerClassname: PropTypes.string,
  children: PropTypes.node
}
